import * as React from 'react'

function CheckCircleGreen({
  width = 82,
  height = 82,
  fill = '#218500',
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 82 82"
    >
      <path
        d="M41.418 23.429c9.936 0 17.99 8.054 17.99 17.99 0 9.935-8.054 17.99-17.99 17.99-9.935 0-17.99-8.055-17.99-17.99 0-9.936 8.055-17.99 17.99-17.99zm0 2.51c-8.549 0-15.48 6.93-15.48 15.48 0 8.549 6.931 15.479 15.48 15.479 8.55 0 15.48-6.93 15.48-15.48 0-8.549-6.93-15.48-15.48-15.48zm6.643 11.245a1.255 1.255 0 011.775 1.775l-8.805 8.806a1.255 1.255 0 01-1.714.057l-5.419-4.742a1.254 1.254 0 111.653-1.889l4.535 3.968z"
        fill={fill}
        fillRule="evenodd"
      />
    </svg>
  )
}

export default CheckCircleGreen
